// کارت «ادامه راه‌اندازی» صفحه خانه (AP-PLT-04): تا کامل شدن مراحل الزامی Setup Wizard برای دارنده plt.onboarding.manage؛ ورود نخست
// (Wizard هرگز باز نشده) مستقیم به /setup هدایت می‌شود.
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import { useTranslation } from '@phoenix/i18n';
import { faDigits } from '@phoenix/ui';
import { Link as RouterLink, Navigate } from 'react-router';
import { SETUP_PATH, useOnboarding } from './common';

export function SetupContinueCard() {
  const { t } = useTranslation('plt');
  const onboarding = useOnboarding();
  const view = onboarding.data;

  if (!onboarding.allowed || !view || view.requiredComplete) {
    return null;
  }
  if (!view.started) {
    return <Navigate to={SETUP_PATH} replace />;
  }

  const done = Number(view.completedSteps);
  const total = Math.max(1, Number(view.availableSteps));
  return (
    <Card variant="outlined" data-testid="setup-continue">
      <CardContent>
        <Typography variant="h2" component="h2" gutterBottom>
          {t('plt:setup.continue_title')}
        </Typography>
        <Typography color="text.secondary">
          {t('plt:setup.progress', { done: faDigits(done), total: faDigits(Number(view.availableSteps)) })}
        </Typography>
        <LinearProgress
          variant="determinate"
          value={(done / total) * 100}
          sx={{ mt: 1.5 }}
          aria-label={t('plt:setup.progress_label')}
        />
      </CardContent>
      <CardActions>
        <Button component={RouterLink} to={SETUP_PATH} variant="contained" data-testid="setup-continue-link">
          {t('plt:setup.continue')}
        </Button>
      </CardActions>
    </Card>
  );
}
